<template>
    <div class="bg-titulo">
        <div class="row">
            <h2>
                <strong>
                    {{ title }}
                </strong>
            </h2>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'c-title',
        props: ['title']
    }
</script>